<search-manufacturers [assignedOnly]=true [showSearch]=false [showAddNew]="false"></search-manufacturers>
